<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gQANyZ/e9781466827905_cover.jpg?1713218500211" alt="This image is the cover for the book Lady in Red"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lady in Red
      </h1>
      <p class="bookDescription body article font2">
        <p>She was a spirited young heiress. He was a handsome baronet with a promising career in government. The marriage of Lady Seymour Dorothy Fleming and Sir Richard Worsley had the makings of a fairy tale—but ended as one of the most scandalous and highly publicized divorces in history.<br/><br/>In February 1782, England opened its newspapers to read the details of a criminal conversation trial in which the handsome baronet Sir Richard Worsley attempted to sue his wife's lover for an astronomical sum in damages. In the course of the proceedings, the Worsleys' scandalous sexual arrangements, voyeuristic tendencies, and bed-hopping antics were laid bare. The trial and its verdict stunned society, but not as much as the unrepentant behavior of Lady Worsley.<br/><br/>Sir Joshua Reynolds captured the brazen character of his subject when he created his celebrated portrait of Lady Worsley in a fashionable red riding habit, but it was her shocking affairs that made her divorce so infamous that even George Washington followed it in the press. Impeccably researched and written with great flair, Hallie Rubenhold's <i>The Lady in Red</i> is a lively and moving true history that presents a rarely seen picture of aristocratic life in the Georgian era.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Hallie Rubenhold
      </h2>
      
      <p class="authorDescription body article"><P>Hallie Rubenhold was born in Los Angeles to a British father and an American mother. She is a young British art historian and writer whose first book, <I>The Covent Garden Ladies</I>, created a small sensation when it was published in the UK in 2005. She lives in London.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f7bd93f2